// 为了兼容以前端钩子, 需要将 formdata 转换成以前的 OptionsSelections

export type OptionsSelectionsMap = Map<string, number | null>;

export const getOptionsSelections = (allFormData: any) => {
  const map: OptionsSelectionsMap = new Map();

  for (const [, value] of Object.entries(allFormData)) {
    if (typeof value === "object" && value !== null && "option_id" in value && "value_index" in value) {
      const optionId = value.option_id as string;

      map.set(optionId, parseInt(value.value_index as string, 10));
    }
  }

  return map;
}
